import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import './chunk-590a6902.js';
import './chunk-ea9bc877.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-113685dc.js';
import { A as Autocomplete } from './chunk-79ac4d01.js';
export { A as BAutocomplete } from './chunk-79ac4d01.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/autocomplete.js
// module id = eCA0
// module chunks = 0 1